import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Home extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (

      <main className="ant-layout-content MainLayout_content__2mZF9">

        <main className="py-6 container">
          <section className="hero">
            <div className="hero-body">
              <div className="has-text-centered">
                <h1 className="ant-typography" style={{ color: "var(--text-color)" }}>The Launchpad Protocol for Everyone!</h1>
              </div>
              <p className="custom-subtitle has-text-centered">PinkSale helps everyone to create their own tokens and token sales in few seconds.</p>
              <p className="custom-subtitle has-text-centered">Tokens created on PinkSale will be verified and published on explorer websites.</p>
            </div>
            <div className="custom-hero-buttons"><a href="/launchpad/create?chain=BSC">Create Now</a><a className="learn" href="https://docs.pinksale.finance" target="_blank" rel="noreferrer nofollow">Learn more</a></div>
          </section>
          <div className="section">
            <nav className="stats">
              <div className="stat has-text-centered">
                <div className="stat-box">
                  <p className="title">$353.8M</p>
                  <p className="heading">Total Liquidity Raised</p>
                </div>
              </div>
              <div className="stat has-text-centered">
                <div className="stat-box">
                  <p className="title">13844</p>
                  <p className="heading">Total Projects</p>
                </div>
              </div>
              <div className="stat has-text-centered">
                <div className="stat-box">
                  <p className="title">1.4M</p>
                  <p className="heading">Total Participants</p>
                </div>
              </div>
              <div className="stat has-text-centered">
                <div className="stat-box">
                  <p className="title">$218.8M</p>
                  <p className="heading">Total Values Locked</p>
                </div>
              </div>
            </nav>
          </div>
          <div className="custom-features-section">
            <div className="has-text-centered">
              <h3 className="custom-title">A Suite of Tools for Token Sales.</h3>
            </div>
            <p className="custom-subtitle">A suite of tools were built to help you create your own tokens and launchpads in a fast, simple and cheap way, with no prior code knowledge required and 100% decentralized!</p>
            <div className="custom-features">
              <div className="custom-feature">
                <div className="custom-feature-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>Standard</h3>
                  <p>Mint standard tokens on ETH, BSC, AVAX, Fantom, Polygon.</p>
                </div>
              </div>
              <div className="custom-feature">
                <div className="custom-feature-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>Deflationary</h3>
                  <p>Generate deflationary tokens with tax and/or charity functions.</p>
                </div>
              </div>
              <div className="custom-feature">
                <div className="custom-feature-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>Customization</h3>
                  <p>Create a token sale for your own custom token easily.</p>
                </div>
              </div>
              <div className="custom-feature">
                <div className="custom-feature-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>Launchpad</h3>
                  <p>Use the token you mint to create a launchpad with just a few clicks</p>
                </div>
              </div>
              <div className="custom-feature">
                <div className="custom-feature-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>Branding</h3>
                  <p>Adding logo, social links, description, listing on PinkSale.</p>
                </div>
              </div>
              <div className="custom-feature">
                <div className="custom-feature-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>Management</h3>
                  <p>The portal to help you easily update content for your launchpad.</p>
                </div>
              </div>
              <div className="custom-feature">
                <div className="custom-feature-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>Community</h3>
                  <p>Promote your launchpad to thousands of buyers on PinkSale.</p>
                </div>
              </div>
              <div className="custom-feature">
                <div className="custom-feature-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>Locking</h3>
                  <p>Lock your liquidity to PinkSwap, PancakeSwap after presale.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="section-projects">
            <h3 className="custom-title">A Growing Protocol Ecosystem.</h3>
            <p className="custom-subtitle">We build a suite of tools for the world of decentralized finance. PinkMoon, PinkSale, PinkElon PinkLock, PinkSwap, we Pink everything!</p>
            <div className="projects">
              <div className="project">
                <div className="project-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>PinkMoon</h3>
                  <p>The best launchpad for professional teams</p>
                </div>
              </div>
              <div className="project">
                <div className="project-box"><img src="https://www.pinkswap.finance/pinksale.png" />
                  <h3>PinkSale</h3>
                  <p>Launch a token sale with a few clicks.</p>
                </div>
              </div>
              <div className="project">
                <div className="project-box"><img src="https://www.pinkswap.finance/pinkswap.png" />
                  <h3>PinkSwap</h3>
                  <p>Swap tokens and farming $PinkS.</p>
                </div>
              </div>
              <div className="project">
                <div className="project-box"><img src="https://www.pinkswap.finance/pinklock.png" />
                  <h3>PinkLock</h3>
                  <p>Locking liquidity on PinkSwap.</p>
                </div>
              </div>
              <div className="project">
                <div className="project-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>PinkElon</h3>
                  <p>The first meme token on PinkMoon.</p>
                </div>
              </div>
              <div className="project">
                <div className="project-box"><img src="https://www.pinkswap.finance/pinkmoon.png" />
                  <h3>PinkWallet</h3>
                  <p>Crypto wallet, buy, store, exchange &amp; earn.</p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </main>



    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Home);
